// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_1EgmT"};